export type StableCoin = {
  name: string;
  abb: string;
  logo: string;
  chain: any[];
};

export const evmCoins: StableCoin[] = [
  {
    name: "USD Tether",
    abb: "USDT",
    logo: "/chain_icons/usdt_logo.png",
    chain: ['polygon','base'],
  },
  {
    name: "USDFC",
    abb: "USDFC",
    logo: "/chain_icons/usdfc_logo.png",
    chain: ['fvm',],
  },
  {
    name: "Axelar USDC",
    abb: "axlUSDC",
    logo: "/chain_icons/usdc_logo.png",
    chain: ['fvm',],
  },
  {
    name: "USD Coin (PoS)",
    abb: "USDC.e",
    logo: "/chain_icons/usdc_logo.png",
    chain: ['polygon'],
  },
  {
    name: "USD Coin",
    abb: "USDC",
    logo: "/chain_icons/usdc_logo.png",
    chain: ['polygon','base'],
  },

];

export const coreumCoin: StableCoin[] = [
  {
    name: "Coreum Staking Coin",
    abb: "CORE",
    logo: "/chain_icons/coreum_color.png",
    chain: [],
  },
]
export const radixCoin: StableCoin[] = [
  {
    name: "Radix XRD Coin",
    abb: "XRD",
    logo: "/chain_icons/radix_logo.png",
    chain: [],
  },
]